import {createStrokeSVG} from './TEMPLATE'

// iconoir: share-ios
export const ArrowOutOfBoxModified_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M20 13V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V13',
    'M12 15V3M12 3L8.5 6.5M12 3L15.5 6.5',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})

// iconoir: share-ios
export const ArrowOutOfBox_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M20 13V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V13',
    'M12 15V3M12 3L8.5 6.5M12 3L15.5 6.5',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})
